import { ActionType } from "../../classes/calendar-actions";

/**
 * Dispatch this when you wish to listen to an image being loaded.
 * @param src
 */
export function waitForImage(src: string) {
    return {
        type: ActionType.WaitForImage,
        value: src
    }   
}

/**
 * Once the onLoad function is triggered on an img, dispatch this.
 * @param src
 */
export function imageHasLoaded(src: string) {
    return {
        type: ActionType.ImageHasLoaded,
        value: src
    }
}